import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Center, Flex } from '@chakra-ui/react';
import { forwardRef } from 'react';
export const DragBar = forwardRef(function DragBar({ isTouching, onToggle, buttonContainerProps, ...props }, ref) {
    return (_jsx(Flex, { ref: ref, w: "70%", mx: "auto", h: "25px", justify: "center", ...props, onClick: onToggle, children: _jsx(Center, { cursor: "pointer", userSelect: "none", ...buttonContainerProps, children: _jsx(Box, { w: "42px", h: "5px", rounded: "full", userSelect: "none", bgColor: isTouching
                    ? 'rgba(255, 255, 255, 0.29)'
                    : 'rgba(255, 255, 255, 0.2)', _active: {
                    bgColor: 'black',
                } }) }) }));
});
